import TextCreate from 'core/display/simple/Text'

export default class TimerText extends TextCreate{
  constructor(data) {
    super(data)
    this.totalSeconds = 0
    setInterval(this.tick.bind(this), 1000)
  }

  tick() {
    this.update(this.getTime())
  }

  getTime() {
    ++this.totalSeconds

    const newData = new Date(this.totalSeconds * 1000).toISOString().substr(11, 8)
    return `${newData}`
  }
}
